
export default {
    data() {
        return {
            tab: null,
        }
    },
}
